function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultConfig = require("./defaultConfig");
var isMarketHost = function isMarketHost(host, domains) {
  return domains.some(function (domain) {
    return host.endsWith(domain);
  });
};
var extractEventName = function extractEventName(targetUrl, _ref) {
  var elementsDomain = _ref.elementsDomain,
    marketDomains = _ref.marketDomains,
    tutsplusDomain = _ref.tutsplusDomain;
  var currentUrl = window.location.host;
  // eventName will be 'internal_click' by default, but we can override it here if the URL is pointing to another site
  if (targetUrl.host === currentUrl) return "internal_click";
  if (targetUrl.host.endsWith(elementsDomain)) {
    if (currentUrl.endsWith(elementsDomain)) {
      return "internal_click";
    } else {
      return "elements_click";
    }
  }
  if (isMarketHost(targetUrl.host, marketDomains)) {
    if (isMarketHost(currentUrl, marketDomains)) {
      return "internal_click";
    } else {
      return "market_click";
    }
  }
  if (targetUrl.host === "placeit.net") return "placeit_click";
  if (targetUrl.host.endsWith(tutsplusDomain) && currentUrl.endsWith(tutsplusDomain)) return "internal_click";
  return "external_click";
};

/**
 * @typedef LinkAttributes
 * @property {?string} [linkUrl]
 * @property {?string} [linkDomain]
 * @property {?string} [linkQuery]
 * @property {?string} [linkAnchor]
 * @property {?string} [eventName]
 */

/**
 * Extracts link attributes from an HTML element.
 * @param {(HTMLElement|HTMLAnchorElement)} element
 * @param {?(import('./defaultConfig').Config)} [customConfig]
 * @returns {LinkAttributes}
 */
var extractLinkAttributes = function extractLinkAttributes(element) {
  var customConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = _objectSpread(_objectSpread({}, defaultConfig), customConfig);
  var linkAttributes = {};

  // If this element isn't a link, it won't have any link attributes for us to extract.
  if (!element || !element.href) return linkAttributes;

  // If the `href` is just a path without a host/origin, we need to provide a base URL for it.
  // `HTMLAnchorElement.href` is a stringifier so it _should_ always have a host:
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement/href
  // but we provide the URL of the current page as the optional `base` argument to cover any unexpected edge cases.
  var targetUrl = new URL(element.href, window.location.href);

  // If this is something other than a regular web link (e.g. a mailto: link), treat it as an external link
  // and don't try to extract any web-specific attributes from it. Just set the whole thing as the linkUrl.
  if (!["https:", "http:"].includes(targetUrl.protocol)) {
    linkAttributes.eventName = "external_click";
    linkAttributes.linkUrl = targetUrl.toString();
    return linkAttributes;
  }
  var queryParams = targetUrl.searchParams;
  queryParams["delete"]("_ga"); // Remove _ga autolinker query param, it'll just create noise in GA

  linkAttributes.linkUrl = targetUrl.origin + targetUrl.pathname;
  linkAttributes.linkDomain = targetUrl.host;
  linkAttributes.linkQuery = queryParams.toString();
  linkAttributes.linkAnchor = targetUrl.hash;
  linkAttributes.eventName = extractEventName(targetUrl, config);
  return linkAttributes;
};
module.exports = extractLinkAttributes;